import React from 'react';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from 'components/ActivitiesRegistrationDetails/ActivitiesRegistrationHeader';

import { convertToReal, convertMinutesToPeriod } from 'helpers/converters';

const WEEK_DAYS = [
  { value: 1, label: 'Segunda-feira' },
  { value: 2, label: 'Terça-feira' },
  { value: 3, label: 'Quarta-feira' },
  { value: 4, label: 'Quinta-feira' },
  { value: 5, label: 'Sexta-feira' },
  { value: 6, label: 'Sábado' },
  { value: 7, label: 'Domingo' }
];

const formatItem = item => {
  const hasSince = item?.since !== undefined && item?.since !== null && +item.since > 0;
  const hasPeriod = item?.period !== undefined && item?.period !== null;
  const hasPrice = item?.price !== undefined && item?.price !== null;

  const since = hasSince ? convertMinutesToPeriod(item.since) : null;
  const period = hasPeriod ? convertMinutesToPeriod(item.period) : null;
  const price = hasPrice ? convertToReal(item.price) : null;

  if(hasSince) {
    return [
      `A partir de ${since}`,
      period ? `a cada ${period}` : null,
      price ? `somar o valor ${price}` : null
    ].filter(Boolean).join(' ');
  }

  if(hasPeriod) {
    return [
      `Até ${period}`,
      price ? `cobrar o valor de ${price}` : null
    ].filter(Boolean).join(' ');
  }

  if(hasPrice) {
    return `Cobrar o valor de ${price}`;
  }

  return '--';
}

const formatTime = time => {
  if(!time) {
    return '--';
  }

  return moment(time, ['HH:mm:ss', 'HH:mm']).format('HH:mm');
}

const formatWeekDays = weekDays => {
  if(!weekDays?.length) {
    return '--';
  }

  return WEEK_DAYS
    ?.filter(day => weekDays?.map(Number)?.includes(day.value))
    ?.map(day => day.label)
    ?.join(', ') || '--';
}

function RegisterFields({ register }) {
  return(
    <>
      {Object.keys(register).includes('name') && (
        <Row>
          <Typography color='primary'>
            <b>Nome</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.name || '--'}
          </Typography>
        </Row>
      )}
      {Object.keys(register).includes('description') && (
        <Row>
          <Typography color='primary'>
            <b>Descrição</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {register?.description || '--'}
          </Typography>
        </Row>
      )}
      {Object.keys(register).includes('weekDays') && (
        <Row>
          <Typography color='primary'>
            <b>Dias da semana</b>
          </Typography>
          <Typography color='textSecondary' style={{ marginLeft: 5 }}>
            {formatWeekDays(register?.weekDays)}
          </Typography>
        </Row>
      )}
      {Object.keys(register).includes('startTime') && (
        <Row>
          <Typography color='primary'>
            <b>Hora inicial</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {formatTime(register?.startTime)}
          </Typography>
        </Row>
      )}
      {Object.keys(register).includes('endTime') && (
        <Row>
          <Typography color='primary'>
            <b>Hora final</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {formatTime(register?.endTime)}
          </Typography>
        </Row>
      )}
      {Object.keys(register).includes('tolerance') && (
        <Row>
          <Typography color='primary'>
            <b>Tolerância</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {convertMinutesToPeriod(register?.tolerance)}
          </Typography>
        </Row>
      )}
      {Object.keys(register).includes('maximumValue') && (
        <Row>
          <Typography color='primary'>
            <b>Valor máximo</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {convertToReal(register?.maximumValue)}
          </Typography>
        </Row>
      )}
      {Object.keys(register).includes('maximumPeriod') && (
        <Row>
          <Typography color='primary'>
            <b>Período máximo</b>
          </Typography>
          <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
            {convertMinutesToPeriod(register?.maximumPeriod)}
          </Typography>
        </Row>
      )}
      {Object.keys(register).includes('items') && register?.items?.length > 0 && (
        <>
          <Row>
            <Typography color='primary'>
              <b>Períodos</b>
            </Typography>
          </Row>
          {register.items.map((item, index) => (
            <Row key={index} marginTop={5}>
              <Typography color='textSecondary'>
                {formatItem(item)}
              </Typography>
            </Row>
          ))}
        </>
      )}
    </>
  );
}

export default function PriceTableUpdate({ activityData, lastRegister, newRegister }) {
  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Registro Anterior</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              <RegisterFields register={lastRegister} />
            </Grid>
          </Grid>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginTop: 10, marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Novo Registro</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              <RegisterFields register={newRegister} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}